import { FormEvent, useEffect, useState } from 'react';

import { LoginActionCreator } from '../../actionCreators';
import './styles.css';

export type LoginModalStateProps = {
  error?: string;
  loading: boolean;
};

export type LoginModalDispatchProps = {
  login: LoginActionCreator;
};

type LoginModalProps = LoginModalStateProps & LoginModalDispatchProps;

export default function LoginModal(props: LoginModalProps): JSX.Element {
  const { error, loading, login } = props;

  const [username, setUsername] = useState('');
  useEffect(() => {
    const appRoot = document.getElementById('app-root');
    if (appRoot) {
      appRoot.style.filter = 'blur(5px)';
      appRoot.style.transform = 'scale(1.03)';
    }
    return () => {
      if (appRoot) {
        appRoot.style.filter = '';
        appRoot.style.transform = '';
      }
    };
  }, []);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    login({ login: username, password: 'quickblox' });
  };

  return (
    <div className="login-modal">
      <form className="login" onSubmit={handleSubmit}>
        <label htmlFor="name">
          <h2>Enter your name before joining a call:</h2>
        </label>
        <input
          autoFocus
          disabled={loading}
          id="name"
          name="username"
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          required
          type="text"
          value={username}
        />
        {error ? <span className="error">{error}</span> : null}
        <button disabled={loading || username.length < 1} type="submit">
          {loading ? <div className="loader" /> : 'Join the Call'}
        </button>
      </form>
    </div>
  );
}
